import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export default {
  termoLGPD: function(usuario, aceite) {
        return Vue.http.post('/api/menu/termolgpd', { documento: usuario.documento, aceite });
  },
  termoFornecedor: function (usuario, aceite) {
    return Vue.http.post('/api/menu/termofornecedor', { documento: usuario.documento, aceite });
  }
}



// WEBPACK FOOTER //
// ./FrontEnd/js/menu-servico.js